// botton crea riconsegna
import {Dialog, DialogActions, DialogContent} from "@material-ui/core";
import {useState} from "react";
import {
    Button,
    FileField,
    FileInput,
    FormWithRedirect,
    SaveButton,
    TextInput,
    useCreate,
    useNotify,
    useRecordContext,
    useRefresh
} from "react-admin";
import {useToggler} from "../../shared/hooks/useToggler";
import IconCancel from "@material-ui/icons/Cancel";
import {useOptions} from "../../shared/hooks/useOptions";

import {initInput} from "../../shared/utils";


export const AddDeliveryAttachmentButton = () => {
  const { value, setTrue, setFalse } = useToggler();
  const record = useRecordContext();
  const notify = useNotify();
  const [create] = useCreate();
  const refresh = useRefresh();
  const onClick = (values: any) => {
    setLoading(true);
    create("delivery_attachments", values, {
      onSuccess: () => {
        notify("ra.notification.created", "success");
        setLoading(false);
        setFalse()
        refresh();
      },
      onFailure: (e: any) => {
        setLoading(false);
        notify("ra.notification.bad_item", "error")
      },
    });
  };

  const [loading, setLoading] = useState(false);
  const { data: optionsAttachment } = useOptions("delivery_attachments", "GET");
  const { data: options } = useOptions("deliveries", "GET");

  return options && optionsAttachment ? (
    <>
      <Button
        disabled={!!!record?.client}
        onClick={(e) => {
          e.stopPropagation();
          setTrue();
        }}
        label={"Aggiungi Allegato"}
      ></Button>

      <Dialog
        open={value}
        onClick={(e) => e.stopPropagation()}
        fullWidth
        maxWidth="sm"
      >
        <FormWithRedirect
          resource="project-collaborators"
          initialValues={{ delivery: record.id }}
          save={onClick}
          render={({ handleSubmitWithRedirect, saving }) => (
            <>
              <DialogContent>

                <FileInput
                  {...initInput("file", optionsAttachment, true)}
                  labelSingle="Trascina o seleziona un file 
                  (tiff, tif, png, jpeg, jpg, pdf, txt, doc, docx, xls, xlsx, msg, eml)"
                >
                  <FileField source="src" title="title" />
                </FileInput>

                <TextInput
                  source="notes"
                  label="Note"
                  fullWidth
                />

              </DialogContent>
              <DialogActions>
                <Button
                  label="ra.action.cancel"
                  onClick={setFalse}
                  disabled={loading}
                >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={handleSubmitWithRedirect}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  ) : null;
};
